"use client"
import {
  Box,
  Typography,
  Container,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useTheme,
  Link,
} from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { useNavigate } from "react-router";

export default function RulesAndGuidelines() {
  const theme = useTheme()
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        bgcolor: "#3f51b5",
        py: 6,
        // minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      id="rules"
    >
      <Container maxWidth="md">
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: 1,
          }}
        >
          <Typography
            variant="h3"
            component="h1"
            sx={{
              color: "#3f51b5",
              fontWeight: 500,
              mb: 4,
            }}
          >
            Rules and Guidelines
          </Typography>

          <Accordion
            defaultExpanded
            sx={{
              boxShadow: "none",
              "&:before": { display: "none" },
              mb: 1,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#3f51b5" }} />}
              sx={{
                p: 0,
                "& .MuiAccordionSummary-content": {
                  m: 0,
                },
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 500, color: "#000" }}>
                Individual Educator Submissions
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 3, pt: 0 }}>
              <Typography variant="body1">
                All participants must be individual educators—teachers, administrators, or curriculum
                specialists—submitting their own work (no team entries).
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion
            defaultExpanded={false}
            sx={{
              boxShadow: "none",
              "&:before": { display: "none" },
              mb: 1,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#3f51b5" }} />}
              sx={{
                p: 0,
                "& .MuiAccordionSummary-content": {
                  m: 0,
                },
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 500, color: "#000" }}>
                Four Deliverables
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 3, pt: 0 }}>
              <Typography variant="body1">
                You will submit four sequential deliverables, from an AI-assisted Problem Statement to a final Refined
                Proposal, each building on the previous one.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion
            defaultExpanded={false}
            sx={{
              boxShadow: "none",
              "&:before": { display: "none" },
              mb: 1,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#3f51b5" }} />}
              sx={{
                p: 0,
                "& .MuiAccordionSummary-content": {
                  m: 0,
                },
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 500, color: "#000" }}>
                Judging Criteria
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 3, pt: 0 }}>
              <Typography variant="body1">
                Submissions are evaluated on Relevance & Problem Clarity, Innovation & Practicality, Critique Depth,
                Refinement Quality, and Overall Impact.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion
            defaultExpanded={false}
            sx={{
              boxShadow: "none",
              "&:before": { display: "none" },
              mb: 1,
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#3f51b5" }} />}
              sx={{
                p: 0,
                "& .MuiAccordionSummary-content": {
                  m: 0,
                },
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 500, color: "#000" }}>
                Responsible Use of AI
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ px: 3, pt: 0 }}>
              <Typography variant="body1">
                While encouraged to use AI tools to develop ideas, please follow ethical guidelines, credit AI-generated
                content, and ensure proposals reflect genuine educational insights.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Link 
              component="button" 
              onClick={() => navigate("./rules-and-guidelines")} 
              color="primary" 
              sx={{ textDecoration: "none", cursor: "pointer" }}
            >
              <Typography variant="body1">Learn More About Submission Guidelines</Typography>
            </Link>
          </Box>
        </Paper>
      </Container>
    </Box>
  )
}

